import React, { useState, Fragment, useEffect, useRef, useMemo } from "react";

import { FrameIntegration } from "@/types/types";
import IntegrationOptionsGrid from "./IntegrationOptionsGrid";
import { useDeviceChangeListener } from "@plutoxyz/web-proofs";
import { AlertError } from "../AlertError";
import { useFirstWebProofState } from "./useFirstWebProofState";
import { Frame } from "@plutoxyz/react-frame";
import {
  plutopseudoBankPlaywrightScript,
  redditUsernamePlaywrightScript,
  venmoTransactionsPlaywrightScript,
} from "@/utils/playwrightScripts";
import FramePlaceholder, {
  WIDGET_MAX_HEIGHT,
  WIDGET_MIN_HEIGHT,
} from "../FramePlaceholder";

const FirstAutomation = () => {
  const [mounted, setMounted] = useState(false);
  const { state, updateState } = useFirstWebProofState();

  const { deviceType, isIos, extensionInstalled, isExtensionSupported } =
    useDeviceChangeListener();
  const isTabletOrMobile = deviceType === "mobile";

  useEffect(() => {
    setMounted(true);
  }, []);

  const frameIntegrations: FrameIntegration[] = [
    {
      id: "reddit",
      title: "Reddit Karma",
      description: "View your Reddit karma",
      src: "https://upload.wikimedia.org/wikipedia/en/thumb/b/bd/Reddit_Logo_Icon.svg/1920px-Reddit_Logo_Icon.svg.png",
      displayName: "Reddit Karma",
      disabled: false,
      playwrightScript: redditUsernamePlaywrightScript,
      // brand: {
      //   name: "Reddit",
      //   logo: "https://upload.wikimedia.org/wikipedia/en/thumb/b/bd/Reddit_Logo_Icon.svg/1920px-Reddit_Logo_Icon.svg.png",
      // },
    },
    {
      id: "pluto-pseudo-bank",
      title: "Bank Balance",
      description: "View your bank balance",
      src: "/your-app.svg",
      displayName: "Bank Balance",
      disabled: false,
      playwrightScript: plutopseudoBankPlaywrightScript,
      // brand: {
      //   name: "Pluto Pseudo Bank",
      //   logo: "https://pluto-images.surge.sh/your-app.svg",
      // },
    },
    // {
    //   id: "venmo-transaction-history",
    //   title: "Venmo Transaction History",
    //   description: "View your Venmo transaction history",
    //   src: "/Venmo.webp",
    //   displayName: "Venmo Transaction History",
    //   disabled: false,
    //   playwrightScript: venmoTransactionsPlaywrightScript,
    //   brand: {
    //     name: "Venmo",
    //     logo: "https://pluto-images.surge.sh/Venmo.webp",
    //   },
    // },
  ];

  const handleSelect = (optionName: string) => {
    const selectedOption = frameIntegrations?.find(
      (option) => option.id === optionName
    );
    if (!selectedOption) return;
    updateState({
      selectedIntegration: selectedOption,
      proofOutput: "",
      proofResultError: null,
    });
  };

  return (
    <div className="flex flex-col  place-content-center items-center md:place-content-start md:items-start gap-2 ">
      <div className="flex flex-col gap-2 min-h-[300px] w-full">
        <div className="flex flex-col w-full">
          <IntegrationOptionsGrid
            frameIntegrations={frameIntegrations}
            currentOption={state?.selectedIntegration?.id}
            handleSelect={handleSelect}
            isLoading={state.loading}
          />
        </div>

        {state.proofResultError && (
          <AlertError errorMessage={state.proofResultError} />
        )}
        {/* Container for Frame and Placeholder */}
        {/* Remove explicit height, let placeholder dictate size */}

        <div className="relative">
          {/* Placeholder - rendered normally to set container height */}
          <FramePlaceholder />

          {/* Actual Frame - conditionally rendered, absolute position OVER placeholder */}
          {state?.selectedIntegration?.playwrightScript && (
            <div className="absolute inset-0 top-0 left-0 z-10">
              <Frame
                script={state.selectedIntegration.playwrightScript}
                brand={state.selectedIntegration.brand}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default FirstAutomation;
